import React, { memo } from 'react'
import { RadioGroup as RadioGroupUI, FormControl, FormLabel, FormHelperText } from '@material-ui/core';
import PropTypes from 'prop-types';
import RadioGroupElement from './RadioGroupElement';

import getObjectValue from 'libs/getObjectValue'
import { withStyles } from '@material-ui/styles';

const style = theme => ({
	error: {
		marginTop: 0,
		marginBottom: theme.spacing(1),
	}
})

function RadioGroup({
	classes,
	formikProps,
	label,
	id,
	items,
	children,
	className,
	required,
	noError,
	onChange = ()=> {},
	disabled
}) {
	const errorValue = getObjectValue(id, formikProps.errors, '')
	const touched = getObjectValue(id, formikProps.touched, false)
	const value = getObjectValue(id, formikProps.values, '')
	const editable = getObjectValue('_editable', formikProps.values, true);

	const isError = !noError && (!!errorValue && touched)

	// const isError = !!formikProps.errors[id] && formikProps.touched[id]
	const helperText = (isError && errorValue) || ' ';

	let _label = label;
	if (required) _label += '*';

	return (
		<FormControl
			error={isError}
			className={className}
		>
			<FormLabel>{_label}</FormLabel>
			<RadioGroupUI
				name={id}
				onChange={(event) => {
					onChange(event);
					formikProps.handleChange(event);
				}}
				onBlur={formikProps.handleBlur}
				// value={formikProps.values[id]}
				value={value}
			>
				{items.map((item, i) => {
					const isStr = typeof item === 'string';
					const value = isStr ? item : String(item.value);
					const label = isStr ? item : item.label;

					return (
						<RadioGroupElement
							key={i}
							value={value}
							disabled={!editable || disabled}
						>
							{label}
						</RadioGroupElement>
					)
				})}
				{children}
			</RadioGroupUI>
			<FormHelperText className={classes.error}>{helperText}</FormHelperText>
		</FormControl>
	)
}

RadioGroup.propTypes = {
	classes: PropTypes.any,
	label: PropTypes.string,
	id: PropTypes.string,
	items: PropTypes.arrayOf(
		PropTypes.oneOfType([
			PropTypes.shape({
				value: PropTypes.any.isRequired,
				label: PropTypes.string.isRequired,
			}),
			PropTypes.string.isRequired,
		])
	),
	formikProps: PropTypes.object,
}

RadioGroup.defaultProps = {
	items: []
}

export default withStyles(style)(memo(RadioGroup, (prevProps, nextProps) => {
	if (prevProps.label !== nextProps.label) return false;
	if (prevProps.id !== nextProps.id) return false;
	if (JSON.stringify(prevProps.items) !== JSON.stringify(nextProps.items)) return false;
	if (prevProps.children !== nextProps.children) return false;
	const id = nextProps.id;
	// if (prevProps.formikProps.values[id] !== nextProps.formikProps.values[id]) return false;
	// if (prevProps.formikProps.errors[id] !== nextProps.formikProps.errors[id]) return false;
	// if (prevProps.formikProps.touched[id] !== nextProps.formikProps.touched[id]) return false;
	if (getObjectValue(id, prevProps.formikProps.values) !== getObjectValue(id, nextProps.formikProps.values)) return false;
	if (getObjectValue(id, prevProps.formikProps.errors) !== getObjectValue(id, nextProps.formikProps.errors)) return false;
	if (getObjectValue(id, prevProps.formikProps.touched) !== getObjectValue(id, nextProps.formikProps.touched)) return false;
	return true;
}))